import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from '@react-native-async-storage/async-storage'; // or the storage you are using
import authReducer from './slices/authSlice';
import errorReducer from './slices/errorSlice';
import platformParamsReducer from './slices/platformSlice';
import { combineReducers } from 'redux';
import { createLogger } from 'redux-logger';

const persistConfig = {
  key: 'root',
  storage,
  whitelist : ['auth']
};

const rootReducer = combineReducers({
  errorSheet: errorReducer,
  auth: authReducer,
  platformParams: platformParamsReducer,
});

const loggerMiddleware = createLogger({
  predicate: () => true,
  timestamp: true,
  diff: true,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(loggerMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

const persistor = persistStore(store);

export { store, persistor };

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

